import React from 'react';
import PropTypes from 'prop-types';
import convertToFormErrors from 'utils/convertToFormErrors';
import { notice } from 'ducks/notifications';
import { reduxForm } from 'redux-form';
import validators from 'utils/validators';
import generateFormValidation from 'utils/generateFormValidation';
import api from 'api';
import { withRouter } from 'react-router-dom';
import Field from 'form/Field';
import Form from 'form/Form';
import SubmitButton from 'form/SubmitButton';
import Component from 'BaseComponent';
import { connect } from 'react-redux';

@withRouter
@connect()

@reduxForm({
  form: 'CompleteAccountAttivation',
  validate: generateFormValidation({
    password: [validators.required()],
  }),
  onSubmit(values, dispatch, props) {
    const { token } = props.match.params;
    dispatch(api.activateAccount({
      data: {
        type: 'account',
        attributes: {
          token,
          password: values.password,
        },
      },
    }))
    .then(() => {
      dispatch(notice('SetPassword.success'));
      props.history.push('/sites');
    })
    .catch((response) => {
      return Promise.reject(convertToFormErrors(response));
    });
  },
})

export default class CompleteAccountAttivation extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }

  render() {
    const { handleSubmit, submitting, error, dirty } = this.props;

    return (
      <div className="island">
        <div className="island__wrap">
          <a href="https://www.hardypress.com">
            <div className="island__title" />
          </a>
          <div className="island__content">
            <div className="island__content__title">
              Choose your password
            </div>
            <Form error={error} onSubmit={handleSubmit}>
              <Field label="ResetPassword.password" name="password" placeholder="*********">
                <input type="password" className="form__input--large" />
              </Field>
              <SubmitButton
                dirty={dirty}
                className="button button--primary button--expand button--huge"
                submitting={submitting}
                label="SetPassword.submit"
              />
            </Form>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/CompleteAccountAttivation.jsx